import React from 'react'
import { PromotionalFooterPure, HeaderHLPure, DialogSystemGLPure, SimpleLoading } from '../../pures';
import AssembliesConfigView from './assemblies-config.view';
import './assemblies.view.css';

const AssembliesView = (props) => {
    let {
        titleHeader,
        isLoadingView,
        showLoadingRequesting,
        showCompletedRequesting,
        showErrorRequesting,
        toggleLoadingRequesting,
        toggleCompletedRequesting,
        toggleErrorRequestingFalse,
        messageComplete,
        messageError
    } = props

    if (isLoadingView) return <div className='standard-wrapper'>
        <SimpleLoading />
    </div>

    return (
        <div className='standard-wrapper'>
            <div className='assembliesView-wrapper'>
                <div className='assembliesView-header'>
                    <HeaderHLPure title={titleHeader} />
                </div>
                <div className='assembliesView-body'>
                    {
                        <AssembliesConfigView {...props} />
                    }
                </div>
                <div className='assembliesView-footer'>
                    <PromotionalFooterPure />
                </div>
                <DialogSystemGLPure
                    showLoadingRequesting={showLoadingRequesting}
                    toggleLoadingRequesting={toggleLoadingRequesting}

                    showCompletedRequesting={showCompletedRequesting}
                    toggleCompletedRequesting={toggleCompletedRequesting}
                    messageComplete={messageComplete}

                    showErrorRequesting={showErrorRequesting}
                    toggleErrorRequesting={toggleErrorRequestingFalse}
                    messageError={messageError}
                />
            </div>
        </div>
    )
}

export { AssembliesView as default }